module.exports = __webpack_public_path__ + "img/pc_p3_y1.4d55a3f1.png";